import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { Dropdown } from '../../components/widgets';
import { CustomMetricsContext } from '../context';
import css from '../page.css';

function CohortPeriodsEditor({ periods, onChange }) {
    const { cohortPeriods, allMetrics } = useContext(CustomMetricsContext);

    const getMetricDisplayName = metricName =>
        allMetrics.find(({ name }) => name === metricName)?.display_name || metricName;

    if (!Object.keys(periods).length) {
        return null;
    }

    return (
        <div className={css.periodsContainer}>
            <div className={css.periodsTitle}>
                <Translate id="STATIC.COHORT_PERIODS" />:
            </div>
            {Object.entries(periods).map(([metricName, period]) => (
                <div key={metricName} className={css.periodRow}>
                    <div className={css.periodLabel}>{getMetricDisplayName(metricName)}</div>
                    <Dropdown
                        items={cohortPeriods}
                        selected={period}
                        valueField="period_id"
                        onSelection={selectedPeriod => onChange(metricName, selectedPeriod)}
                    />
                </div>
            ))}
        </div>
    );
}

CohortPeriodsEditor.propTypes = {
    periods: PropTypes.objectOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default CohortPeriodsEditor;
